module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp23_9006.bef3fe33.png";